module.exports = __webpack_public_path__ + "static/media/richtig1.bb48f163.jpg";